import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {DocumentScreenComponent} from './document-view/document-screen/document-screen.component';
import {DocumentThumbnailComponent} from './document-view/document-thumbnail/document-thumbnail.component';
import {NavBarComponent} from './nav-bar/nav-bar.component';
import {TopBarComponent} from './top-bar/top-bar.component';
import {RouterModule} from '@angular/router';
import {HttpClientModule} from '@angular/common/http';
import {NgCircleProgressModule} from 'ng-circle-progress';
import {DocumentsGridComponent} from './documents-list/documents-grid/documents-grid.component';
import { PublicationGridComponent } from './publication-list/publication-grid/publication-grid.component';
import { PublicationGridLibraryComponent } from './publication-list/publication-grid-library/publication-grid-library.component';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import { PublicationThumbnailComponent } from './publication-view/publication-thumbnail/publication-thumbnail.component';
import {LongPressModule} from 'ngx-long-press/dist/src';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';

@NgModule({
  imports: [
    CommonModule,
    HttpClientModule,
    NgCircleProgressModule.forRoot(),
    ReactiveFormsModule,
    FormsModule,
    LongPressModule,
    RouterModule
  ],
  declarations: [
    DocumentScreenComponent,
    DocumentThumbnailComponent,
    NavBarComponent,
    TopBarComponent,
    DocumentsGridComponent,
    PublicationGridComponent,
    PublicationGridLibraryComponent,
    PublicationThumbnailComponent
  ],
  exports: [
    HttpClientModule,
    RouterModule,
    ReactiveFormsModule,
    FormsModule,

    DocumentScreenComponent,
    DocumentThumbnailComponent,
    NavBarComponent,
    TopBarComponent,
    DocumentsGridComponent,
    PublicationGridComponent,
    PublicationGridLibraryComponent,
    PublicationThumbnailComponent
  ]
})
export class SharedModule {}



// WEBPACK FOOTER //
// ./src/app/shared/shared.module.ts